const positionInZone = (x, y, zoomTransform, zone) => {
	x = (x - zoomTransform.x) / zoomTransform.k - (zone ? zone.position.x : 0)
	y = (y - zoomTransform.y) / zoomTransform.k - (zone ? zone.position.y : 0)
	return {x, y}
}

export {
	positionInZone,
}
